import { render, staticRenderFns } from "./withdrawchargesreport.vue?vue&type=template&id=66ad4a24"
import script from "./withdrawchargesreport.vue?vue&type=script&lang=js"
export * from "./withdrawchargesreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports